import { type ProjectStatusEnum } from '@/graphql/generated/graphql';

export type ScheduleType = 'human' | 'equipment' | 'sub_contractor' | 'placeholder';
export type ViewMode = 'day' | 'week' | 'month';

export interface ScheduleV2 {
  id: string;
  ids: string[]; // all constituent IDs (>1 when bar spans multiple days)
  name: string;
  resourceId: string;
  resourceType: ScheduleType;
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  projectId: string;
  color?: string;
  source?: string | null;
  title?: string | null;
  onHire?: boolean | null;
  descriptionOfService?: string | null;
  startTime?: string | null; // ISO 8601 UTC
  endTime?: string | null; // ISO 8601 UTC
  status?: string | null;
}

export type ProjectStatus = ProjectStatusEnum.NotStarted | ProjectStatusEnum.InProgress | ProjectStatusEnum.OnHold;

export interface ProjectAddress {
  id: string;
  title?: string | null;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  locationType: string;
}

export interface ProjectV2 {
  id: string;
  name: string;
  code: string;
  status: ProjectStatus;
  enableWeekends: boolean;
  schedules: ScheduleV2[];
  mainAddress: ProjectAddress | null;
  subLocations: ProjectAddress[];
  shifts: string | null; // raw JSON string from project settings
  holidays?: string | null; // raw JSON string from project/company settings
}

export interface ResourceV2 {
  id: string;
  name: string;
  resourceType: ScheduleType;
  description?: string;
  status?: 'available' | 'assigned' | 'unavailable';
}

export interface FilterState {
  status: ProjectStatusEnum[];
  projectIds: string[];
  tagIds: string[];
  searchBy: string;
  clientIds: string[];
  city: string | null;
  zip: string | null;
  placeholderOnly: boolean;
  issueIds: string[];
  issueSearch: string;
  eventSearch: string;
}

export const DEFAULT_FILTER_STATE: FilterState = {
  status: [],
  projectIds: [],
  tagIds: [],
  searchBy: '',
  clientIds: [],
  city: null,
  zip: null,
  placeholderOnly: false,
  issueIds: [],
  issueSearch: '',
  eventSearch: '',
};

export interface ScheduleModalAddress {
  id: string;
  title?: string | null;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  locationType: string;
}

export interface ScheduleModalResource {
  id: string;
  name: string;
  resourceType: 'human' | 'equipment' | 'sub_contractor' | 'placeholder';
  description?: string;
}

export interface ShiftOption {
  id: string;
  label: string;
  startTime: string; // 'HH:mm'
  endTime: string; // 'HH:mm'
}
